import insertScriptWithId from '../../../../../utils/create-content-script'
import sha256 from 'crypto-js/sha256'

export default data => {

    const { items, usdItemTotal, enterpriseId, userId, email, tagId } = data
    const hashedEmail = sha256(email)

    const scriptContent = `
        if (!window.cj) window.cj = {};
        cj.sitePage = {
            enterpriseId: ${enterpriseId},
            pageType: 'cart',
            userId: '${userId}',
            emailHash: '${hashedEmail}',
            cartSubtotal: ${usdItemTotal?.amount},
            currency: '${usdItemTotal?.currency}',
            items: [
                ${items?.map(item => {
                return `{"unitPrice": "${item.realPrice?.amount}", "itemId": "${item.sku}", "quantity": "${item?.quantity}"}`
                }).join(',')}
            ]
        };
        
    
        (function(a,b,c,d){
        a='https://www.mczbf.com/tags/${tagId}/tag.js';
        b=document;c='script';d=b.createElement(c);d.src=a;
        d.type='text/java'+c;d.async=true;
        d.id='cjapitag';
        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
        })();
    `

    insertScriptWithId('cj-script', scriptContent)
}